import {createSimpleContext} from "../../../utils/context.tsx"
import {TCheckboxesAddContext} from "./types.ts"

export const CheckboxesAddContext = createSimpleContext<TCheckboxesAddContext>("checkboxes add")
